import { ArrowUpperRightIcon, CalendarIcon } from "../../../../../Icons";
import * as styles from "./styles";

function EventsPopUp({ title, subtitle, desc, articleUrl }) {
  const handleClose = (event) => {
    event.stopPropagation();
    const newWindow = window.open(articleUrl, "_blank");

    // Optional: Check if the new window was successfully opened
    if (newWindow) {
      newWindow.focus(); // Bring focus to the new window/tab
    } else {
      alert("Popup blocked! Please allow popups for this website.");
    }
  };
  return (
    <>
      <div className={styles.popUpTitleContainer}>
        <div>
          <div className={styles.popUpTitleText}>{title}</div>
          {subtitle && (
            <div className={styles.popUpSubTitleText}>
              <CalendarIcon />
              <div className="text-md text-black">{subtitle}</div>
            </div>
          )}
        </div>
        <div className={styles.popUpCloseContainer}>
          <button alt="Open article in new window button" onClick={handleClose}>
            <span className="sr-only">Open Article</span>
            <ArrowUpperRightIcon />
          </button>
        </div>
      </div>
      <div className={styles.popUpContentContainer}>{desc}</div>
    </>
  );
}

export default EventsPopUp;
